import { BackgroundImage, Box, Button, Center, Chip, Container, Group, List, Stack, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import AppLogo from "@/components/AppLogo";
import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { contactWebsite } from "@/configs/contactInformation";
import Icon from "@/utils/icons";

import styles from "./LayoutPromo.module.css";

const randomImageNumber = `0${Math.floor(Math.random() * 9) + 1}`;
const backgroundImage = new URL(`/src/assets/backgrounds/${randomImageNumber}.jpg`, import.meta.url).href;

const LayoutAside = () => {
  const { t } = useTranslation();

  return (
    <BackgroundImage src={backgroundImage} h="100%">
      <AppLogo h={72} ml="md" />
      <Center h="90%">
        <Container size="sm" className={styles["card-blurred"]}>
          <Container size="xs" pt="xl">
            <Stack justify="center">
              <Text fw="bold" c="dimmed">
                {t("registration.product-promo-pretitle")}
              </Text>
              <Stack gap={0}>
                <Title order={1}>{t("registration.product-promo-title-1")}</Title>
                <Title order={1} fs="italic">
                  {t("registration.product-promo-title-2")}
                </Title>
              </Stack>
              <Group mb="xs">
                <Chip size="xs">{t("registration.product-promo-chips.1")}</Chip>
                <Chip size="xs">{t("registration.product-promo-chips.2")}</Chip>
                <Chip size="xs">{t("registration.product-promo-chips.3")}</Chip>
              </Group>
              <Text>{t("registration.product-promo-description")}</Text>
              <List my="md" icon={<Icon.GO_FORWARD size={14} style={{ transform: "rotate(-45deg)" }} />}>
                <List.Item>
                  <Text>{t("registration.product-promo-list-item-1")}</Text>
                </List.Item>
                <List.Item>
                  <Text>{t("registration.product-promo-list-item-2")}</Text>
                </List.Item>
                <List.Item>
                  <Text>{t("registration.product-promo-list-item-3")}</Text>
                </List.Item>
                <List.Item>
                  <Text>{t("registration.product-promo-list-item-4")}</Text>
                </List.Item>
                <List.Item>
                  <Text>{t("registration.product-promo-list-item-5")}</Text>
                </List.Item>
              </List>
              <Box mb="xl">
                <Button
                  component="a"
                  color={SYSTEM_COLORS.primary}
                  href={contactWebsite}
                  rightSection={<Icon.GO_FORWARD />}
                >
                  {t("registration.learn-more")}
                </Button>
              </Box>
            </Stack>
          </Container>
        </Container>
      </Center>
    </BackgroundImage>
  );
};

export default LayoutAside;
